import requests from "./httpService";

const PolicyServices = {
 
  getPolicyById: async (id, body) => {
    return requests.get(`/dayRentalPolicy/${id}`, body);
  },

  updatePolicy: async (id, body) => {
    return requests.put(`/dayRentalPolicy/update/${id}`, body);
  },

  
};

export default PolicyServices;
